import Axios, { AxiosError } from 'axios'
import { ElMessage } from 'element-plus'

export const httpClient = Axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 20000,
})

httpClient.interceptors.response.use(
  (config) => config,
  (error: AxiosError) => {
    if (![200, 201].includes(error.response?.status || 0)) {
      ElMessage.error(error.response?.data || 'Error')
    }
    return Promise.reject(error)
  },
)
